module.exports = __webpack_public_path__ + "static/media/3.047b508c.png";